import { datadogLogs } from '@datadog/browser-logs';
import { showToast } from 'components/Toast';
import { getApiDebuggingId, getApiErrorStatus, getApiHttpStatus } from 'helpers/rtk-utils';
import { useReorderClientFiltersMutation } from 'services/clientFiltersApi';
import { FILTER_ORDER_ERROR, FILTER_ORDER_OUTDATED, FILTER_ORDER_SAVED } from './constants';

/** The returned save resolves to whether the order was saved; failures are logged and toasted here. */
export const useSaveFilterOrder = (clientId: number) => {
  const [reorderFilters] = useReorderClientFiltersMutation();

  return (filterIds: string[]): Promise<boolean> =>
    reorderFilters({ clientId, body: { filter_ids: filterIds } })
      .unwrap()
      .then(() => {
        showToast(FILTER_ORDER_SAVED, 'success');
        return true;
      })
      .catch((error: unknown) => {
        const httpStatus = getApiHttpStatus(error);
        // A 400 means the list no longer matches the client's filters, e.g. one was created meanwhile.
        const isOutdated = httpStatus === 400;
        const logContext = {
          client_id: clientId,
          status: getApiErrorStatus(error),
          debugging_id: getApiDebuggingId(error),
        };
        if (isOutdated) {
          datadogLogs.logger.info('Client filter order rejected as outdated', logContext);
        } else {
          datadogLogs.logger.error(
            'Failed to save client filter order',
            logContext,
            error instanceof Error ? error : undefined
          );
        }
        showToast(isOutdated ? FILTER_ORDER_OUTDATED : FILTER_ORDER_ERROR, 'error', httpStatus);
        return false;
      });
};
